@font-size: 14px;

.drawer-dimensions-input {
  display: grid;
  grid-template-columns: auto 1fr auto;
  font-size: @font-size;

  > .dimensions-input-label {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 10px;
  }

  .size-input {
    width: 75px;
  }
}
